import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { APP_CONFIG, EnvironmentModel } from '@fh-client-interaction-frontends/fh-app-config';
import { map, Observable } from 'rxjs';
import { LoginSetupModel } from '../../helpers/objects/response/login-setup/login-setup-model';
import { RegisterSetupModel } from '../../helpers/objects/response/register-setup/register-setup-model';

@Injectable({
  providedIn: 'root'
})
export class SetupService {
  constructor(private http: HttpClient, @Inject(APP_CONFIG) protected appConfig: EnvironmentModel) {}

  login(): Observable<LoginSetupModel[]> {
    return this.http.get<any>(this.appConfig.api + 'setup/login/' + this.appConfig.apiPartnershipId).pipe(map((response) => response.body.loginTypes as LoginSetupModel[]));
  }

  register() {
    return this.http
      .get<any>(this.appConfig.api + 'setup/register/' + this.appConfig.apiPartnershipId)
      .pipe(map((response) => response.body as RegisterSetupModel));
  }
}
